export enum ACTION_TYPES {
	ACCOUNT_SIGNED_IN = 'ACCOUNT_SIGNED_IN',
	ACCOUNT_RESET = 'ACCOUNT_RESET',
	ACCOUNT_RESET_NEW_CODE = 'ACCOUNT_RESET_NEW_CODE',
	ACCOUNT_REQUEST_RESET = 'ACCOUNT_REQUEST_RESET',
	ACCOUNT_SIGNED_OUT = 'ACCOUNT_SIGNED_OUT',
	DEVICE_REMEMBERED = 'DEVICE_REMEMBERED',
	INVITE_RESENT = 'INVITE_RESENT',
	INVITE_ACCEPTED = 'INVITE_ACCEPTED',
	PASSWORD_CHANGE = 'PASSWORD_CHANGE',
	MFA_REQUEST_SMS = 'MFA_REQUEST_SMS',
	MFA_REQUEST_SMS_NEW_CODE = 'MFA_REQUEST_SMS_NEW_CODE',
	MFA_REQUEST_APP = 'MFA_REQUEST_APP',
	MFA_UPDATED = 'MFA_UPDATED',
	PHONE_NUMBER_SUBMITTED = 'PHONE_NUMBER_SUBMITTED',
}

export enum ACTION_STATUS {
	SUCCESS = 'SUCCESS',
	FAILURE = 'FAILURE',
}

export type ActionTrackingRequest = {
	actionType: ACTION_TYPES;
	status?: ACTION_STATUS;
	emailAddress?: string;
	cognitoUserId?: string;
	inviteId?: string;
	inviteStatus?: string;
	errorCode?: string;
	errorMessage?: string;
};
